import { Haptics, ImpactStyle } from '@capacitor/haptics';

export const useHapticFeedback = () => {
  const triggerLight = async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // Haptics not available on web or unsupported device
      console.debug('Haptic feedback not available');
    }
  };

  const triggerMedium = async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Medium });
    } catch (error) {
      console.debug('Haptic feedback not available');
    }
  };

  const triggerHeavy = async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Heavy });
    } catch (error) {
      console.debug('Haptic feedback not available');
    }
  };

  const triggerSelection = async () => {
    try {
      await Haptics.selectionStart();
    } catch (error) {
      console.debug('Haptic feedback not available');
    }
  };

  return {
    triggerLight,
    triggerMedium, 
    triggerHeavy,
    triggerSelection
  };
};